var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$classes['modal-header']},[_c('h4',{class:_vm.$classes['modal-title']},[_vm._v(" "+_vm._s(_vm.title)+" ")]),(_vm.message)?_c('p',{class:_vm.$classes['modal-message']},[_vm._v(" "+_vm._s(_vm.message)+" ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }